module.exports = __webpack_public_path__ + "img/circle-p.82c03ee4.svg";